module.exports = __webpack_public_path__ + "img/pdf.99d1b7c3.svg";